import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import axios from "axios";
import "./beitraege.scss";

const Beiträge = () => {

    const [beitraege, setBeiträge] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [openIndices, setOpenIndices] = useState([0]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const beitraegeRes = await axios.get(`https://mk-lorenzen.it/admin/wp-json/wp/v2/oeffentliche-beitraege?per_page=100`);
                if (beitraegeRes.data && beitraegeRes.data.length > 0) {
                    setBeiträge(beitraegeRes.data);
                }
                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    const toggleAccordion = (index) => {
        if (openIndices.includes(index)) {
            setOpenIndices(openIndices.filter(i => i !== index)); // schließen
        } else {
            setOpenIndices([...openIndices, index]); // öffnen
        }
    };

    return (
        <div className="beitraege">
            <Helmet>
                <title>Öffentliche Beiträge | Musikkapelle St. Lorenzen</title>
            </Helmet>
            <motion.div
                className="header"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >
                <h1>Öffentliche Beiträge</h1>
                <p>Verzeichnis der erhaltenen Beiträge im Sinne der Transparenzpflicht für Vereine, gemäß Artikel 1, Absätze 125-129 des Gesetzes vom 04.08.2017, Nr. 124.</p>
            </motion.div>
            <div className="container">
                <div className="accordion">
                    {beitraege.map((beit, index) => {
                        const isOpen = openIndices.includes(index);
                        return isLoading ? (<div className="loading" />) : (
                            <div key={index} className={`item ${isOpen ? "open" : ""}`}>
                                <div className="top" onClick={() => toggleAccordion(index)}>
                                    <div className="icon">
                                        {isOpen ? <RemoveIcon /> : <AddIcon />}
                                    </div>
                                    <h4>Jahr {beit.title.rendered}</h4>
                                </div>
                                {isOpen && <div className="content" dangerouslySetInnerHTML={{ __html: beit.content.rendered }} />}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Beiträge;
